import { useNavigate } from 'react-router-dom';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

export const useNavigateToNewsDetail = () => {
  const navigate = useNavigate();
  const { topicId, whitelabelURL } = useTopicContext();
  const { currentUser } = useDefaultAppContexts();
  const { flagDsIsolationNewsDetailPage } = useFeatureFlag();

  const onClick = (id: number) => {
    const linkPath =
      topicId && !whitelabelURL
        ? Routes.topic_new_path(topicId, id)
        : Routes.new_json_path(id);

    // Never refresh page in topics & FO
    if (topicId || currentUser) {
      navigate(linkPath);

      return;
    }

    if (flagDsIsolationNewsDetailPage) {
      window.location.href = linkPath;

      return;
    }

    navigate(linkPath);
  };

  return { onClick };
};
